import { Box } from "@mui/material";
import React, { useState } from "react";

import { useUserProfile } from "api/services/useUserProfile";
import { useShouldSeeReviewOnboarding } from "hooks/useShouldSeeReviewOnboarding/useShouldSeeReviewOnboarding";
import { GuidanceModal } from "new-components/modals/GuidanceModal";

import reviewImageUsageExampleSrc from "../assets/review-image-usage-example.png";

export function ReviewOnboardingModal() {
  const shouldSeeReviewOnboarding = useShouldSeeReviewOnboarding();
  const [dismissed, setDismissed] = useState(false);
  const open = shouldSeeReviewOnboarding && !dismissed;
  const { updateUserProfile } = useUserProfile();

  const handleConfirmation = () => {
    setDismissed(true);
    updateUserProfile({
      review_onboarded: true,
    });
  };

  return (
    <GuidanceModal
      title="Review"
      subtitle="The review page is where you can label your own data. It is equivalent to what our cloud labelers use when queries are escalated for verification."
      open={open}
      onClose={handleConfirmation}
      onConfirmation={handleConfirmation}
      steps={[
        "Question you're answering about image.",
        "Add notes that will help Groundlight answer your question here.",
        "Examples of previously answered queries for reference.",
        "Answer buttons with shortcuts noted where applicable.",
      ]}
      image={<Box component="img" src={reviewImageUsageExampleSrc} className="max-w-[352px] w-full" />}
    />
  );
}
